import React from 'react';
import { Badge } from '../../ui-kit';

const styleClasses = {
  completed: 'success',
  extended: 'success',
  open: 'primary',
  resolvable: 'primary',
  withdrawn: 'secondary',
  expired: 'danger',
  failed: 'danger',
  reverted: 'info',
  approved: 'success',
  rejected: 'danger',
  pending_counter_exchange: 'warning',
  pending_approval: 'warning'
};

// used in the UserDutyTransactionsWidget for filtering
export const allStates = Object.keys(styleClasses);

const TransactionStateLabel = props => {
  const key = `classy_enum.schedule/exchanges/duty_exchange_status.${props.transactionState}`;
  const translation = I18n.t(key);
  return <Badge variant={styleClasses[props.transactionState]}>{translation}</Badge>;
};

export default TransactionStateLabel;
